export { AccountDelete as default } from './account-delete';
